import React, { useEffect, useRef } from 'react';
import { VbpPopover } from '../app';

interface InfoPopupProps {
    text: string;
    children?: JSX.Element;
}

export const InfoPopup = ({ text, children }: InfoPopupProps): JSX.Element => {
    const popoverRef = useRef(null);
    const popover = useRef<VbpPopover | null>(null);

    const initPopover = () => {
        if (popover.current) {
            return;
        }

        // Bootstrap resolves the default container (false) to document.body and
        // then type-checks it. When the body is not yet available the resolved
        // value is null and the type check throws, so only initialise once both
        // the trigger element and the body exist, and pass the body explicitly.
        if (popoverRef.current && document.body) {
            popover.current = new VbpPopover(popoverRef.current, {
                html: true,
                content: text,
                placement: 'top',
                trigger: 'focus',
                container: document.body,
            });
        }
    };

    useEffect(() => {
        initPopover();

        return () => {
            if (popover.current) {
                popover.current?.dispose();
                popover.current = null;
            }
        };
    });

    if (children) {
        const newChildren = React.cloneElement(children, {
            tabIndex: 0,
            ref: popoverRef,
        });

        return <>{newChildren}</>;
    }

    return (
        <i
            ref={popoverRef}
            className="fa fa-info-circle ms-2"
            style={{
                cursor: 'pointer',
            }}
            // biome-ignore lint/a11y/noNoninteractiveTabindex: Bootstrap popover uses trigger:'focus', which requires the element to be focusable
            tabIndex={0}
        />
    );
};
